module.exports = __webpack_public_path__ + "static/img/smart-site.ed2fd0d7.png";